import { ProgramCodesService } from "./implementations/programCodes.service";

export default defineNuxtPlugin((nuxtApp) => {
  const programcodes = new ProgramCodesService(
    nuxtApp.$axios,
    nuxtApp.$config.public.sgApiUrl
  );

  return {
    provide: {
      programcodes: programcodes,
    },
  };
});
